import { call, all, takeLatest, put } from "redux-saga/effects";
import createFetchFunction from "../utils/create-fetch-func";
import createFetchSagaPattern from "../fetch/fetch-saga-pattern-creator";
import getFetchInstance from "./../utils/fetch";
import getDataFromResponse from "../utils/get-data-from-res";
import {
    fetchQuestions,
    fetchQuestionDiscussion,
    IFetchQuestionsPayload,
    IInsertQuestionPayload,
    IUpdateQuestionPayload,
    IDeleteQuestionPayload,
    fetchQuestion,
    IFetchQuestionPayload,
    IFetchQuestionAnswerPayload
} from "./question.actions";

function* insertQuestionAsync({
    payload: { data },
}: {
    payload: IInsertQuestionPayload;
}) {
    yield getFetchInstance().post("questionquiz/insert", data);
}

function* fetchQuestionsAsync({
    payload: { data },
}: {
    payload: IFetchQuestionsPayload;
}) {
    const res = yield getFetchInstance().get(
        `questionquiz/getQuestion/${data.id}`
    );
    const questions = getDataFromResponse(res);
    yield put(
        fetchQuestions({
            questions,
        })
    );
}

function* fetchQuestionAsync({
    payload: { param, data },
}: {
    payload: IFetchQuestionPayload;
}) {
    const res = yield getFetchInstance().post(
        `questionquiz/getQuestion/${param.quiz_id}`,
        data
    );
    const question = getDataFromResponse(res);
    yield put(
        fetchQuestion({
            question,
        })
    );
}

function* updateQuestionAsync({
    payload: { data },
}: {
    payload: IUpdateQuestionPayload;
}) {
    yield getFetchInstance().post("questionquiz/update", data);
}

function* deleteQuestionAsync({
    payload: { data },
}: {
    payload: IDeleteQuestionPayload;
}) {
    yield getFetchInstance().post("questionquiz/delete", data);
}

function* fetchQuestionAnswerAsync({
    payload: { data },
}: {
    payload: IFetchQuestionAnswerPayload;
}) {
    const res = yield getFetchInstance().get(
        `answercorrection/getanswerandquestion/${data.id}`
    );
    const question_answer = getDataFromResponse(res);
    yield put(
        fetchQuestionDiscussion({
            question_answer,
        })
    );
}

function* watchFetchQuestions() {
    yield takeLatest(
        createFetchSagaPattern("QUESTIONS"),
        createFetchFunction("QUESTIONS", fetchQuestionsAsync)
    );
}

function* watchFetchQuestion() {
    yield takeLatest(
        createFetchSagaPattern("QUESTION"),
        createFetchFunction("QUESTION", fetchQuestionAsync)
    );
}

function* watchInsertQuestion() {
    yield takeLatest(
        createFetchSagaPattern("INSERT_QUESTION"),
        createFetchFunction("INSERT_QUESTION", insertQuestionAsync)
    );
}

function* watchUpdateQuestion() {
    yield takeLatest(
        createFetchSagaPattern("UPDATE_QUESTION"),
        createFetchFunction("UPDATE_QUESTION", updateQuestionAsync)
    );
}

function* watchDeleteQuestion() {
    yield takeLatest(
        createFetchSagaPattern("DELETE_QUESTION"),
        createFetchFunction("DELETE_QUESTION", deleteQuestionAsync)
    );
}

function* watchFetchQuestionAnswer() {
    yield takeLatest(
        createFetchSagaPattern("QUESTIONS_DISCUSSION"),
        createFetchFunction("QUESTIONS_DISCUSSION",fetchQuestionAnswerAsync)
    )
}

export default function* quizSagas() {
    yield all([
        call(watchInsertQuestion),
        call(watchFetchQuestions),
        call(watchFetchQuestion),
        call(watchUpdateQuestion),
        call(watchDeleteQuestion),
        call(watchFetchQuestionAnswer)
    ]);
}
